"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Networking = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var ui_vector_graphic_1 = require("@hopin-team/ui-vector-graphic");

var react_1 = tslib_1.__importDefault(require("react"));

var Networking = function Networking(_a) {
  var title = _a.title,
      props = tslib_1.__rest(_a, ["title"]);

  return react_1.default.createElement(ui_vector_graphic_1.VectorGraphic, tslib_1.__assign({}, props, {
    title: title !== null && title !== void 0 ? title : 'Networking',
    viewBox: "0 0 320 250",
    __UIScope: "Networking"
  }), react_1.default.createElement("g", {
    clipPath: "url(#Networking__clip0)"
  }, react_1.default.createElement("rect", {
    width: "280",
    height: "187",
    x: "40",
    y: "53",
    fill: ui_symbols_1.COLOR.GREY[100],
    rx: "12"
  }), react_1.default.createElement("path", {
    stroke: "url(#Networking__paint0_linear)",
    strokeWidth: "2",
    d: "M206.5 185.745c33.137 0 60-26.862 60-60 0-33.137-26.863-60-60-60"
  }), react_1.default.createElement("path", {
    stroke: "url(#Networking__paint1_linear)",
    strokeWidth: "2",
    d: "M259 189.388c18.323-15.132 30-38.023 30-63.643 0-27.437-13.394-51.746-34-66.745"
  }), react_1.default.createElement("path", {
    stroke: "url(#Networking__paint2_linear)",
    strokeWidth: "2",
    d: "M206.5 163.246c20.711 0 37.5-16.79 37.5-37.5 0-20.711-16.789-37.5-37.5-37.5"
  }), react_1.default.createElement("g", {
    filter: "url(#Networking__filter0_d)"
  }, react_1.default.createElement("rect", {
    width: "104.941",
    height: "64",
    x: "192",
    y: "143",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "4"
  }), react_1.default.createElement("rect", {
    width: "97.412",
    height: "56.471",
    x: "195.765",
    y: "146.765",
    fill: ui_symbols_1.COLOR.GREEN[100],
    rx: "4"
  }), react_1.default.createElement("circle", {
    cx: "244.706",
    cy: "175",
    r: "7.529",
    fill: ui_symbols_1.COLOR.GREEN[200]
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREEN[400],
    fillRule: "evenodd",
    d: "M243.451 173.118v1.255a1.254 1.254 0 002.51 0v-1.255a1.255 1.255 0 00-2.51 0zm3.407 2.258a.123.123 0 01.069.079.12.12 0 01-.025.103v.026a2.51 2.51 0 01-1.882 1.276v.65h.47c.087 0 .157.07.157.157v.313c0 .087-.07.157-.157.157h-1.568a.157.157 0 01-.157-.157v-.313c0-.087.07-.157.157-.157h.458v-.634a2.509 2.509 0 01-1.883-1.277.16.16 0 010-.125.15.15 0 01.082-.094l.285-.132a.154.154 0 01.201.066 1.883 1.883 0 003.291-.035.132.132 0 01.173-.056l.329.153z",
    clipRule: "evenodd",
    opacity: "0.2"
  }), react_1.default.createElement("rect", {
    width: "8.471",
    height: "4.706",
    x: "281.412",
    y: "150.059",
    fill: ui_symbols_1.COLOR.RED[300],
    rx: "2.353"
  }), react_1.default.createElement("rect", {
    width: "8.471",
    height: "4.706",
    x: "281.412",
    y: "150.059",
    stroke: ui_symbols_1.COLOR.GREY.WHITE,
    strokeWidth: "0.941",
    rx: "2.353"
  })), react_1.default.createElement("g", {
    filter: "url(#Networking__filter1_d)"
  }, react_1.default.createElement("rect", {
    width: "223",
    height: "136",
    x: "6",
    y: "39",
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    rx: "8"
  }), react_1.default.createElement("rect", {
    width: "207",
    height: "120",
    x: "14",
    y: "47",
    fill: ui_symbols_1.COLOR.BLUE[100],
    rx: "8"
  }), react_1.default.createElement("circle", {
    cx: "118",
    cy: "107",
    r: "16",
    fill: ui_symbols_1.COLOR.BLUE[300],
    opacity: "0.4"
  }), react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.THEME.PRIMARY,
    fillRule: "evenodd",
    d: "M115.333 103v2.667a2.667 2.667 0 005.334 0V103a2.667 2.667 0 10-5.334 0zm7.24 4.8a.26.26 0 01.147.167.254.254 0 01-.053.22v.053a5.333 5.333 0 01-4 2.713v1.38h1c.184 0 .333.15.333.334v.666a.334.334 0 01-.333.334h-3.334a.334.334 0 01-.333-.334v-.666c0-.184.149-.334.333-.334h.974v-1.346a5.333 5.333 0 01-4-2.714.333.333 0 010-.266.316.316 0 01.173-.2l.607-.28a.325.325 0 01.426.14 4.002 4.002 0 006.994-.074.28.28 0 01.366-.12l.7.327z",
    clipRule: "evenodd",
    opacity: "0.2"
  }), react_1.default.createElement("rect", {
    width: "18",
    height: "10",
    x: "196",
    y: "54",
    fill: ui_symbols_1.COLOR.RED[300],
    rx: "5"
  }), react_1.default.createElement("rect", {
    width: "18",
    height: "10",
    x: "196",
    y: "54",
    stroke: ui_symbols_1.COLOR.GREY.WHITE,
    strokeWidth: "2",
    rx: "5"
  }))), react_1.default.createElement("defs", null, react_1.default.createElement("filter", {
    id: "Networking__filter0_d",
    width: "116.235",
    height: "75.294",
    x: "188.235",
    y: "137.353",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "1.882"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "2.824"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), react_1.default.createElement("filter", {
    id: "Networking__filter1_d",
    width: "247",
    height: "160",
    x: "-2",
    y: "27",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, react_1.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), react_1.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), react_1.default.createElement("feOffset", {
    dx: "4"
  }), react_1.default.createElement("feGaussianBlur", {
    stdDeviation: "6"
  }), react_1.default.createElement("feColorMatrix", {
    values: "0 0 0 0 0.886719 0 0 0 0 0.905528 0 0 0 0 0.945833 0 0 0 0.32 0"
  }), react_1.default.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), react_1.default.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), react_1.default.createElement("linearGradient", {
    id: "Networking__paint0_linear",
    x1: "206.5",
    x2: "206.5",
    y1: "65.746",
    y2: "185.745",
    gradientUnits: "userSpaceOnUse"
  }, react_1.default.createElement("stop", {
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0"
  }), react_1.default.createElement("stop", {
    offset: "0.5",
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0.72"
  }), react_1.default.createElement("stop", {
    offset: "1",
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0"
  })), react_1.default.createElement("linearGradient", {
    id: "Networking__paint1_linear",
    x1: "206.5",
    x2: "206.5",
    y1: "43.245",
    y2: "208.245",
    gradientUnits: "userSpaceOnUse"
  }, react_1.default.createElement("stop", {
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0"
  }), react_1.default.createElement("stop", {
    offset: "0.5",
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0.72"
  }), react_1.default.createElement("stop", {
    offset: "1",
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0"
  })), react_1.default.createElement("linearGradient", {
    id: "Networking__paint2_linear",
    x1: "206.5",
    x2: "206.5",
    y1: "88.246",
    y2: "163.246",
    gradientUnits: "userSpaceOnUse"
  }, react_1.default.createElement("stop", {
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0"
  }), react_1.default.createElement("stop", {
    offset: "0.5",
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0.72"
  }), react_1.default.createElement("stop", {
    offset: "1",
    stopColor: ui_symbols_1.COLOR.GREY.WHITE,
    stopOpacity: "0"
  })), react_1.default.createElement("clipPath", {
    id: "Networking__clip0"
  }, react_1.default.createElement("path", {
    fill: ui_symbols_1.COLOR.GREY.WHITE,
    d: "M0 0H320V250H0z"
  }))));
};

exports.Networking = Networking;